const key = (s) => (s || "").trim().toLowerCase();
const fmt = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 }));

const Change = ({ from, to }) => {
  if (from == null || to == null || !from) return null;
  const p = ((to - from) / Math.abs(from)) * 100;
  return <span className={`block text-[10px] ${p > 0 ? "text-sky-700" : p < 0 ? "text-amber-700" : "text-slate-400"}`}>{p > 0 ? "+" : ""}{p.toFixed(1)}%</span>;
};

const Grid = ({ title, years, field, total, testid }) => {
  const names = [];
  years.forEach((y) => (y[field] || []).forEach((r) => { if (!names.some((n) => key(n) === key(r.category))) names.push(r.category); }));
  const val = (y, n) => (y[field] || []).find((r) => key(r.category) === key(n))?.amount;
  return (
    <div className="overflow-x-auto rounded-2xl border border-border bg-white p-4" data-testid={testid}>
      <p className="text-sm font-semibold">{title}</p>
      <table className="mt-2 w-full min-w-[480px] text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-400"><th className="font-medium">Category</th>{years.map((y) => <th key={y.fiscal_year} className="whitespace-nowrap pl-2 text-right font-medium">{y.fiscal_year}</th>)}</tr></thead>
        <tbody>
          <tr className="border-t border-border font-semibold"><td className="py-1.5">Total</td>{years.map((y, i) => <td key={y.fiscal_year} className="text-right align-top">{fmt(y[total])}<Change from={years[i - 1]?.[total]} to={y[total]} /></td>)}</tr>
          {names.map((n) => (
            <tr key={n} className="border-t border-border"><td className="py-1.5 pr-2">{n}</td>
              {years.map((y, i) => <td key={y.fiscal_year} className="text-right align-top">{fmt(val(y, n))}<Change from={i ? val(years[i - 1], n) : null} to={val(y, n)} /></td>)}</tr>))}
        </tbody>
      </table>
    </div>
  );
};

export const BudgetHistory = ({ history, word }) => {
  if (!history?.length) return null;
  const years = history.slice(-5);
  return (
    <section className="space-y-2" data-testid="budget-history">
      <p className="font-serif text-xl">{word === "federal" ? "Federal" : "National"} budget history</p>
      <p className="text-xs text-slate-500">{years.length > 1 ? `Each approved budget, in billions of ${years[years.length - 1].currency}, with the change from the year before.` : "The history builds up as each new budget is approved. Year-on-year changes appear from the second budget."}</p>
      <div className="grid gap-3 lg:grid-cols-2">
        <Grid title="Spending by category" years={years} field="spending" total="total_spending" testid="history-spending" />
        <Grid title="Revenue by source" years={years} field="revenue" total="total_revenue" testid="history-revenue" />
      </div>
    </section>
  );
};
